import axiosRequest from "@/api/axios-optimize"

// 判断仓库名称是否存在
export function judgeCategoryNameExist(data = {}, config = {
  noShowLoading: true, // 不展示全局加载动画
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/category/judgeCategoryNameExist`, data, config)
}

// 获取列表
export function getList(data = {}, config = {
  preventDuplicateRequestsType: "cancel",
  noShowLoading: true // 不展示全局加载动画
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/category`, { params: data, ...config})
}

// 获取详情
export function getDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/category/${data.id}`, { params: {}, ...config})
}

// 更新
export function updateItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.put(`/xiaobuAdmin/product/category/${data.categoryId}`, data, config)
}

// 新增
export function createItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/category`, data, config)
}

// 删除
export function deleteItem(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/category/${data.id}`, { ...config}) // 省略data入参 或 params入参
}

// 批量删除
export function batchDeleteItems(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.delete(`/xiaobuAdmin/product/category/batchDelete`, { data, ...config})
}

// 改变状态
export function changeStatus(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/category/changeStatus`, data, config)
}

// 获取仓库树 配置父级仓库
export function getCategoryTree(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/category/categoryTree`, { params: data, ...config})
}

// 获取分组参数信息
export function getGroupJsonByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "cancel"
}) {
  return axiosRequest.get(`/xiaobuAdmin/product/category/getGroupJsonByCategoryId/${data.id}`, { params: {}, ...config})
}

// 设置分组参数信息
export function setGroupJsonByCategoryId(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.post(`/xiaobuAdmin/product/category/setGroupJsonByCategoryId`, data, config)
}